import { render, staticRenderFns } from "./StaticPageForm.vue?vue&type=template&id=75fe0cc9&"
import script from "./StaticPageForm.vue?vue&type=script&lang=js&"
export * from "./StaticPageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports